// @flow
import { parse } from "date-fns"

import { DATE_TYPES } from "common/records/SearchDate/SearchDate"

export default class UrlParser {
  constructor(reverseTranslate: string => string) {
    this.reverseTranslate = reverseTranslate
  }

  reverseTranslate = null

  urlToSearchDate(urlString: string) {
    const dates = urlString.split("_")
    const plain = {}
    // normal date
    if (dates[0] && dates[0].length === 10) {
      plain.type = DATE_TYPES.DATE_RANGE
      plain.from = parse(dates[0])
      if (dates[1] && dates[1].length === 10) {
        plain.to = parse(dates[1])
      } else {
        plain.to = parse(dates[0])
      }
    }

    if (dates.length === 1) {
      const splitted = dates[0].split("-")
      if (splitted.length === 2) {
        const min = parseInt(splitted[0], 10)
        const max = parseInt(splitted[1], 10)
        if (min <= max && max > 0) {
          plain.min = min
          plain.max = max
          plain.type = DATE_TYPES.TIME_TO_STAY
        }
      } else if (splitted.length === 1) {
        const val = parseInt(splitted[0], 10)
        if (val >= 0) {
          plain.min = val
          plain.max = val
          plain.type = DATE_TYPES.TIME_TO_STAY
        }
      }
    }

    if (this.reverseTranslate) {
      const tKey = this.reverseTranslate(urlString)
      if (urlString === "anytime" || tKey === __("seo.url.anytime")) {
        plain.type = DATE_TYPES.ANYTIME
      }
      if (urlString === "noReturn" || tKey === __("seo.url.no-return")) {
        plain.type = DATE_TYPES.NO_RETURN
      }
    }

    return plain
  }
}
